import { formateISODateToMoment } from "@/utils/index";

const MomentField = ({ value }) => {
  return <div>{formateISODateToMoment(value)}</div>;
};
export default MomentField;
